import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { addAccessToUser, removeAccessFromUser } from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";

const accessLabelMap = {
  general: "General",
  csr: "CSR",
  care_quality: "Care Quality",
  scribing: "Scribing",
  superadmin: "Super Admin",
};

const accessOptions = [
  { label: "General", value: "general" },
  { label: "CSR", value: "csr" },
  { label: "Scribing", value: "scribing" },
  { label: "Care Quality", value: "care_quality" },
];

const AccessList = ({
  localAccessList,
  selectedUser,
  setHasChanges,
  setLocalAccessList,
}) => {
  const [selectedAccessList, setSelectedAccessList] = useState([]);
  const [showAccessEdit, setShowAccessEdit] = useState(false);
  const userData = useUserData();
  const token = userData?.access_token;

  const handleRemoveAccessItem = async (accessKey) => {
    const payload = {
      user_id: selectedUser.user_id,
      access_list: [accessKey],
    };
    try {
      const res = await removeAccessFromUser(payload, token);
      if (res?.status === "success") {
        setLocalAccessList((prev) => prev.filter((key) => key !== accessKey));
        setHasChanges(true);
      }
    } catch (error) {
      console.log("Remove access error:", error);
    }
  };

  const handleAddAccess = async () => {
    if (!selectedAccessList.length) return;
    const payload = {
      user_id: selectedUser.user_id,
      access_list: selectedAccessList.map((a) => a.value),
    };
    try {
      const res = await addAccessToUser(payload, token);
      if (res?.status === "success") {
        setLocalAccessList((prev) => [
          ...new Set([...prev, ...payload.access_list]),
        ]);
        setSelectedAccessList([]);
        setHasChanges(true);
      }
    } catch (error) {
      console.log("Add access error:", error);
    }
  };

  return (
    <Box mb={3}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1}
      >
        <Typography variant="subtitle2" color="textSecondary">
          Access List
        </Typography>
        <IconButton
          size="small"
          onClick={() => setShowAccessEdit((prev) => !prev)}
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box display="flex" flexWrap="wrap" gap={1} mb={1}>
        {localAccessList.map((key, i) => (
          <Chip
            key={i}
            label={accessLabelMap[key] || key}
            onDelete={() => handleRemoveAccessItem(key)}
            variant="outlined"
          />
        ))}
      </Box>

      {showAccessEdit && (
        <>
          <Autocomplete
            multiple
            options={accessOptions.filter(
              (option) => !localAccessList.includes(option.value)
            )}
            value={selectedAccessList}
            onChange={(_, value) => setSelectedAccessList(value)}
            renderInput={(params) => (
              <TextField {...params} label="Select Access" size="small" />
            )}
          />
          <Box mt={1}>
            <Button variant="contained" onClick={handleAddAccess}>
              Add
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default AccessList;
